import AgendaMainScreen from "../agenda/AgendaMainScreen.tsx";
import { useState } from "react";
import ChecklistsScreen from "../modules/checklists/ChecklistsScreen.tsx";

const ScreenSwitcher = ({ userId }: { userId: string }) => {
  const [screen, setScreen] = useState<"Agenda" | "Checklists">("Agenda");
  return (
    <div className="pwa-main">
      <div hidden={screen !== "Agenda"}>
        <AgendaMainScreen />
      </div>
      {screen === "Checklists" && <ChecklistsScreen userId={userId} />}
      <nav aria-label="Navigation principale" className="pwa-navigation">
        <button
          type="button"
          aria-current={screen === "Agenda" ? "page" : undefined}
          className={screen === "Agenda" ? "bg-slate-700 font-semibold" : ""}
          onClick={() => setScreen("Agenda")}
        >
          Agenda
        </button>
        <button
          type="button"
          aria-current={screen === "Checklists" ? "page" : undefined}
          className={
            screen === "Checklists" ? "bg-slate-700 font-semibold" : ""
          }
          onClick={() => setScreen("Checklists")}
        >
          Checklists
        </button>
      </nav>
    </div>
  );
};

export default ScreenSwitcher;
